import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BiSearchAlt2 } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa';
import { ImLocation } from 'react-icons/im';
import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import ProjectsMoreFiltersModal from '../../modals/ProjectsMoreFiltersModal';
import Button from '../Button/Button';
import CustomOverlay from '../CustomOverlay';
import Input from '../Input/Input';
import LocationFiltersOverlay from '../LocationFilterOverlay';
import classes from './projectFilters.module.css';

import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { roomsOptions } from '../../constant/commonData';
import Checkbox from '../Checkbox/Checkbox';
import MapMain from '../maps/MapMain';

const FilterDiv = ({
  text,
  icon,
  iconRight = <MdOutlineKeyboardArrowDown size={20} className={classes.icons} />,
  className = '',
  textClassName = '',
  ...props
}) => {
  return (
    <div className={[classes.dropdownBox, className].join(' ')} {...props}>
      <div>
        {icon} <span className={[textClassName].join(' ')}>{text}</span>
      </div>
      {iconRight && iconRight}
    </div>
  );
};

/*eslint-disable*/
function ProjectFilters({
  onSearch,
  filtersWrapperClass = '',
  containerClass,
  t,
  filters,
  setFilters,
  savedSearch,
  disabledSearch
}) {
  const locationRef = useRef(null);
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { projectTypes, unitTypes, projectStatus, interiorAmenities, exteriorAmenities } =
    useSelector((state) => state?.commonReducer);
  // For Popover
  const [show, setShow] = useState('');
  const [target, setTarget] = useState(null);
  const [screenWidth, setScreenWidth] = useState();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getWindowWidth(setScreenWidth);
  }, []);

  const handleClick = (event, type) => {
    if (type) {
      setShow(type);
    } else {
      setShow('');
    }
    if (event) {
      setTarget(event.target);
    } else {
      setTarget(null);
    }
  };
  // Apply Filters
  function applyFilters(type, data) {
    if (type == 'location') {
      handleClick();
    }
    setFilters((prev) => ({ ...prev, ...data }));
  }

  const handleSearch = () => {
    onSearch && onSearch();
  };

  useEffect(() => {
    if (savedSearch) {
      locationRef?.current?.updateLocation(savedSearch);
    }
  }, [savedSearch]);

  // Location Overlay
  const LocationOverlay = () => (
    <CustomOverlay
      show={show == 'location'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          className={classes.locDiv}
          onClick={(e) => handleClick(e, 'location')}
          icon={
            screenWidth <= 768 ? (
              false
            ) : (
              <ImLocation color={'var(--secondary-clr)'} className={classes.icon} />
            )
          }
          text={
            screenWidth <= 768 ? (
              <ImLocation color={'var(--secondary-clr)'} />
            ) : (
              t('filters.location')
            )
          }
        />
      }>
      <div className={classes.overlayBox}>
        <LocationFiltersOverlay
          setLocationState={setFilters}
          locationState={filters}
          setClose={setShow}
          ref={locationRef}
        />
      </div>
    </CustomOverlay>
  );

  // Unit Types Dropdown
  const UnitTypesDropDown = () => (
    <CustomOverlay
      show={show == 'unit-types'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'unit-types');
          }}
          className={[screenWidth <= 992 ? classes.fullWidth : '', classes.unitTypesDropDown].join(
            ' '
          )}
          text={filters?.unitType?.title?.[selectedLanguage] || t('filters.unitType')}
          textClassName={'maxLine1'}
        />
      }>
      <div className={[classes.overlayBox, classes.p0].join(' ')}>
        <ul className={classes.listOptionsWithBrBtm}>
          {unitTypes?.map((item, key) => (
            <li
              key={key}
              data-selected={filters?.unitType?._id == item?._id}
              onClick={() => {
                setFilters((prev) => ({
                  ...prev,
                  unitType: prev?.unitType?._id == item?._id ? null : item
                }));
                setShow('');
              }}>
              {item?.title?.[selectedLanguage]}
            </li>
          ))}
        </ul>
      </div>
    </CustomOverlay>
  );

  // Project Status Dropdown
  const ProjectStatusDropDown = () => (
    <CustomOverlay
      show={show == 'project-status'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'project-status');
          }}
          className={classes.fullWidth}
          text={filters?.projectStatus?.title?.[selectedLanguage] || t('filters.status')}
          textClassName={'maxLine1'}
        />
      }>
      <div className={[classes.overlayBox, classes.p0].join(' ')}>
        <ul className={classes.listOptionsWithBrBtm}>
          {projectStatus?.map((item, key) => (
            <li
              key={key}
              data-selected={filters?.projectStatus?._id == item?._id}
              onClick={() => {
                setFilters((prev) => ({
                  ...prev,
                  projectStatus: prev?.projectStatus?._id == item?._id ? null : item
                }));
                setShow('');
              }}>
              {item?.title?.[selectedLanguage]}
            </li>
          ))}
        </ul>
      </div>
    </CustomOverlay>
  );

  // Area Dropdown
  const AreaDropDown = () => (
    <Col md={12}>
      <CustomOverlay
        show={show == 'area'}
        target={target}
        handleClose={(e) => handleClick('', e)}
        targetElement={
          <FilterDiv
            onClick={(e) => {
              handleClick(e, 'area');
            }}
            className={screenWidth <= 992 ? classes.fullWidth : ''}
            text={
              filters?.minArea || filters?.maxArea
                ? `${filters?.minArea || 0} - ${filters?.maxArea || '∞'}`
                : t('filters.area')
            }
          />
        }>
        <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
          <Row>
            <Col md={6}>
              <Input
                value={filters?.minArea}
                label={t('filters.minArea')}
                placeholder={t('filters.minAreaPlaceholder')}
                type={'number'}
                setValue={(e) => {
                  setFilters((prev) => ({ ...prev, minArea: e }));
                }}
              />
            </Col>
            <Col md={6}>
              <Input
                label={t('filters.maxArea')}
                placeholder={t('filters.maxAreaPlaceholder')}
                value={filters?.maxArea}
                type={'number'}
                setValue={(e) => {
                  setFilters((prev) => ({ ...prev, maxArea: e }));
                }}
              />
            </Col>
            <Col md={12}>
              <div className={[classes.spBtw, classes.mt20].join(' ')}>
                <Button
                  borderRadius={'9px'}
                  className={classes.clearBtn}
                  onClick={() => {
                    setFilters((prev) => ({ ...prev, minArea: '', maxArea: '' }));
                  }}>
                  {t('filters.clearBtn')}
                </Button>
                <Button
                  borderRadius={'9px'}
                  className={classes.btnMaxContent}
                  onClick={() => {
                    handleClick();
                  }}>
                  {t('filters.applyBtn')}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </CustomOverlay>
    </Col>
  );

  // Rooms Dropdown
  const RoomsDropDown = () => (
    <Col md={12}>
      <CustomOverlay
        show={show == 'rooms'}
        target={target}
        handleClose={(e) => handleClick('', e)}
        targetElement={
          <FilterDiv
            onClick={(e) => {
              handleClick(e, 'rooms');
            }}
            className={screenWidth <= 992 ? classes.fullWidth : ''}
            text={filters?.noOfRooms ? filters?.noOfRooms?.[selectedLanguage] : t('filters.rooms')}
            textClassName={'maxLine1'}
          />
        }>
        <div className={[classes.overlayBox, classes.p0].join(' ')}>
          <ul className={classes.listOptionsWithBrBtm}>
            {roomsOptions?.map((item, key) => (
              <li
                key={key}
                data-selected={filters?.noOfRooms?.[selectedLanguage] == item?.[selectedLanguage]}
                onClick={() => {
                  applyFilters('rooms', {
                    noOfRooms:
                      filters?.noOfRooms?.[selectedLanguage] == item?.[selectedLanguage]
                        ? null
                        : item
                  });
                  setShow('');
                }}>
                {item?.[selectedLanguage]}
              </li>
            ))}
          </ul>
        </div>
      </CustomOverlay>
    </Col>
  );

  return (
    <Container className={`${containerClass}`}>
      <div className={[classes.filters, filtersWrapperClass].join(' ')}>
        <Row className={[classes.row, 'gx-0'].join(' ')}>
          {/* 1st Option */}

          <Col md={2} className={classes.minWidth170}>
            <LocationOverlay />
          </Col>
          <Col md={4} sm={9} xs={8} className={classes.flex2}>
            <MapMain
              setCoordinates={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  lng: e?.lng,
                  lat: e?.lat
                }));
              }}
              address={filters?.address}
              setAddress={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  address: e,
                  nearby: false,
                  province: null,
                  town: null,
                  neighborhood: null
                }));
              }}
              placeholder={t('filters.search')}
              type="places"
              comboRootClassName={classes?.searchInput}
              deleteIcon
            />
          </Col>
          {/* 3rd Option */}
          {screenWidth > 992 && (
            <Col md={2} className={[classes.minWidth170].join(' ')}>
              <UnitTypesDropDown />
            </Col>
          )}

          {screenWidth > 992 && (
            <Col md={2} className={classes.minWidth170}>
              <AreaDropDown />
            </Col>
          )}

          {screenWidth > 992 && (
            <Col md={2} className={classes.minWidth170}>
              <RoomsDropDown />
            </Col>
          )}

          {/* 4th Option */}
          {screenWidth > 1200 && (
            <Col md={2} className={classes.minWidth170}>
              <CustomOverlay
                show={show == 'price'}
                target={target}
                handleClose={(e) => handleClick('', e)}
                targetElement={
                  <FilterDiv
                    onClick={(e) => {
                      handleClick(e, 'price');
                    }}
                    text={
                      filters?.minPrice || filters?.maxPrice
                        ? `${filters?.minPrice || 0} - ${filters?.maxPrice || '∞'}`
                        : t('filters.price')
                    }
                  />
                }>
                <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
                  <Row>
                    <Col md={6}>
                      <Input
                        value={filters?.minPrice}
                        label={t('filters.minPrice')}
                        placeholder={t('filters.minPricePlaceholder')}
                        type={'number'}
                        min={0}
                        setValue={(e) => {
                          setFilters((prev) => ({ ...prev, minPrice: e }));
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <Input
                        label={t('filters.maxPrice')}
                        placeholder={t('filters.maxPricePlaceholder')}
                        value={filters?.maxPrice}
                        type={'number'}
                        setValue={(e) => {
                          setFilters((prev) => ({ ...prev, maxPrice: e }));
                        }}
                        min={0}
                      />
                    </Col>
                    <Col md={12}>
                      <div className={[classes.spBtw, classes.mt20].join(' ')}>
                        <Button
                          borderRadius={'9px'}
                          className={classes.clearBtn}
                          onClick={() => {
                            setFilters((prev) => ({ ...prev, minPrice: '', maxPrice: '' }));
                            handleClick();
                          }}>
                          {t('filters.clearBtn')}
                        </Button>
                        <Button
                          borderRadius={'9px'}
                          className={classes.btnMaxContent}
                          onClick={() => {
                            handleClick();
                          }}>
                          {t('filters.applyBtn')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CustomOverlay>
            </Col>
          )}
          {/* 4th Option */}
          {/* {screenWidth > 1570 && (
            <Col md={2} className={classes.minWidth190}>
              <ProjectStatusDropDown />
            </Col>
          )} */}
          {/* {screenWidth <= 992 && ( */}
          <Col className={classes.minWidth170}>
            <FilterDiv
              onClick={() => {
                setShowModal(true);
              }}
              iconRight={screenWidth <= 768 ? false : <FaFilter className={classes.icon} />}
              text={
                screenWidth <= 768 ? <FaFilter className={classes.icon} /> : t('filters.filter')
              }
            />
          </Col>
          {/* )} */}
          <Button
            variant="secondary"
            borderRadius={'8px'}
            onClick={handleSearch}
            disabled={disabledSearch}
            className={classes.searchBtn}>
            {screenWidth <= 768 ? (
              <BiSearchAlt2 color="var(--white-clr)" size={20} />
            ) : (
              t('filters.searchBtn')
            )}
          </Button>
        </Row>
      </div>
      {showModal && (
        <>
          {/* <style>{`
      .modal-body{
        overflow:visible;
      }
      `}</style> */}
          <ProjectsMoreFiltersModal
            t={t}
            show={showModal}
            setShow={setShowModal}
            onApply={handleSearch}>
            {/* Unit Types */}
            {screenWidth <= 992 && (
              <Col md={12}>
                <UnitTypesDropDown />
              </Col>
            )}

            {/* Area */}
            {screenWidth <= 992 && (
              <Col md={12}>
                <AreaDropDown />
              </Col>
            )}

            {/* Rooms */}
            {screenWidth <= 992 && (
              <Col md={12}>
                <RoomsDropDown />
              </Col>
            )}

            {screenWidth <= 1200 && (
              <Col md={12}>
                <CustomOverlay
                  show={show == 'price'}
                  target={target}
                  handleClose={(e) => handleClick('', e)}
                  targetElement={
                    <FilterDiv
                      onClick={(e) => {
                        handleClick(e, 'price');
                      }}
                      className={classes.fullWidth}
                      text={
                        filters?.minPrice || filters?.maxPrice
                          ? `${filters?.minPrice || 0} - ${filters?.maxPrice || '∞'}`
                          : t('filters.price')
                      }
                    />
                  }>
                  <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
                    <Row>
                      <Col md={6}>
                        <Input
                          value={filters?.minPrice}
                          label={t('filters.minPrice')}
                          placeholder={t('filters.minPricePlaceholder')}
                          type={'number'}
                          min={0}
                          setValue={(e) => {
                            setFilters((prev) => ({ ...prev, minPrice: e }));
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          label={t('filters.maxPrice')}
                          placeholder={t('filters.maxPricePlaceholder')}
                          value={filters?.maxPrice}
                          type={'number'}
                          setValue={(e) => {
                            setFilters((prev) => ({ ...prev, maxPrice: e }));
                          }}
                          min={0}
                        />
                      </Col>
                      <Col md={12}>
                        <div className={[classes.spBtw, classes.mt20].join(' ')}>
                          <Button
                            borderRadius={'9px'}
                            className={classes.clearBtn}
                            onClick={() => {
                              setFilters((prev) => ({ ...prev, minPrice: '', maxPrice: '' }));
                              handleClick();
                            }}>
                            {t('filters.clearBtn')}
                          </Button>
                          <Button
                            borderRadius={'9px'}
                            className={classes.btnMaxContent}
                            onClick={() => {
                              handleClick();
                            }}>
                            {t('filters.applyBtn')}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CustomOverlay>
              </Col>
            )}
            {/* {screenWidth <= 1570 && ( */}
            <Col md={12}>
              <ProjectStatusDropDown />
            </Col>
            {/* )} */}

            {/* Exterior Amenities */}
            <Col md={12}>
              <h6 className={classes.headWithIcon}>{t('filters.exteriorAmenities')}</h6>
            </Col>
            <Col md={12}>
              <ul className={classes.listWrap}>
                {exteriorAmenities?.map((item, key) => (
                  <li key={key}>
                    <Checkbox
                      label={item?.title?.[selectedLanguage]}
                      value={
                        filters?.exteriorAmenities?.find((e) => e?._id == item?._id)?.title?.[
                          selectedLanguage
                        ]
                      }
                      setValue={() => {
                        setFilters((prev) => {
                          const newData = [...prev?.exteriorAmenities];
                          if (newData?.find((e) => e?._id == item?._id)) {
                            return {
                              ...prev,
                              exteriorAmenities: newData?.filter((fItem) => fItem?._id != item?._id)
                            };
                          } else {
                            newData?.push(item);
                          }
                          return { ...prev, exteriorAmenities: newData };
                        });
                      }}
                    />
                  </li>
                ))}
              </ul>
            </Col>

            {/* Interior Amenities */}
            <Col md={12}>
              <h6 className={classes.headWithIcon}>{t('filters.interiorAmenities')}</h6>
            </Col>
            <Col md={12}>
              <ul className={classes.listWrap}>
                {interiorAmenities?.map((item, key) => (
                  <li key={key}>
                    <Checkbox
                      label={item?.title?.[selectedLanguage]}
                      value={
                        filters?.interiorAmenities?.find((e) => e?._id == item?._id)?.title?.[
                          selectedLanguage
                        ]
                      }
                      setValue={() => {
                        setFilters((prev) => {
                          const newData = [...prev?.interiorAmenities];
                          if (newData?.find((e) => e?._id == item?._id)) {
                            return {
                              ...prev,
                              interiorAmenities: newData?.filter((fItem) => fItem?._id != item?._id)
                            };
                          } else {
                            newData?.push(item);
                          }
                          return { ...prev, interiorAmenities: newData };
                        });
                      }}
                    />
                  </li>
                ))}
              </ul>
            </Col>
          </ProjectsMoreFiltersModal>
        </>
      )}
    </Container>
  );
}

export default ProjectFilters;
